import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { DeviceUtils } from '../utils/DeviceUtils';

@Injectable({
  providedIn: 'root'
})
export class AutoScrollService {

  private readonly destroyRef = inject(DestroyRef);
  private isInitialized = false;

  public initialize(): void {
    if (this.isInitialized || !('visualViewport' in window)) {
      return;
    }

    fromEvent(window.visualViewport!, 'resize')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.handleViewportResize());

    this.isInitialized = true;
  }

  private handleViewportResize(): void {
    const viewport = window.visualViewport!;
    const activeElement = document.activeElement;

    document.body.style.height = viewport.height + 'px';
    document.body.style.overflow = 'hidden';

    if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
      setTimeout(() => {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }, 100);
    }
  }
}
